import { mutatorAction } from 'satcheljs';
import type { AdminRbacQueryInput } from '../interfaces';
import { getStore } from './store';

export const updatePermissionMapMutator: (
    permissions: Partial<Record<AdminRbacQueryInput, boolean>>
) => void = mutatorAction(
    'updatePermissionMap',
    (permissions: Partial<Record<AdminRbacQueryInput, boolean>>): void => {
        Object.entries(permissions).forEach(([key, value]) => {
            const input = key as AdminRbacQueryInput;
            getStore().permissionMap.set(input, value);
        });
    }
);

export const removePermissionMutator: (inputs: AdminRbacQueryInput[]) => void = mutatorAction(
    'removePermission',
    (inputs: AdminRbacQueryInput[]): void => {
        inputs.forEach(input => {
            getStore().permissionMap.delete(input);
        });
    }
);

export const endQueryingRbacMutator: (
    results: Partial<Record<AdminRbacQueryInput, boolean>>,
    requstId: number
) => void = mutatorAction(
    'endQueryingRbac',
    (results: Partial<Record<AdminRbacQueryInput, boolean>>, requstId: number): void => {
        for (const [key, value] of Object.entries(results)) {
            const input = key as AdminRbacQueryInput;
            getStore().pendingRequests.delete(input);
            if (getStore().latestedRequestId.get(input) === requstId) {
                getStore().permissionMap.set(input, value);
            }
        }
    }
);

export const failQueryingRbacMutator: (inputs: AdminRbacQueryInput[]) => void = mutatorAction(
    'endQueryingRbac',
    (inputs: AdminRbacQueryInput[]): void => {
        for (const input of inputs) {
            getStore().pendingRequests.delete(input);
            getStore().permissionMap.delete(input);
        }
    }
);

export const updatePendingRequestsMutator: (
    inputs: AdminRbacQueryInput[],
    promise: Promise<void>
) => void = mutatorAction(
    'updatePendingRequests',
    (inputs: AdminRbacQueryInput[], promise: Promise<void>): void => {
        for (const input of inputs) {
            getStore().pendingRequests.set(input, promise);
        }
    }
);

export const incrementCounterMutator: () => void = mutatorAction('incrementCounter', (): void => {
    getStore().counter++;
});

export const markPermissionCounterMutator: (inputs: AdminRbacQueryInput[], id: number) => void =
    mutatorAction('markPermissionCounter', (inputs: AdminRbacQueryInput[], id: number): void => {
        for (const input of inputs) {
            getStore().latestedRequestId.set(input, id);
        }
    });
